import React, { useEffect, useRef, useMemo } from 'react';
import { Toast } from 'primereact/toast';
import Cookies from 'universal-cookie/es6';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import apis from '../../api';
import authenticationService from '../../services/authentication.service';
import notification from '../../assets/notificaciones/SD_ALERT_35.ogg';

function RenewSession() {


  const toast = useRef(null);
  const cookies = new Cookies();
  const headers = {
    authorization: localStorage.getItem('token')
  }
  const audioElement = useMemo(() => new Audio(notification), []);
  useEffect(() => {
    renoveSesion();
  }, []);

  function renoveSesion() {

    if (cookies.get('token')) {
      let expired = (parseInt(localStorage.getItem('expired')) + (3480 * 1000)) - Date.now()
      setTimeout(sayHi, expired)
    }
  }

  const accept = () => {
    if (cookies.get('token')) {
      apis.getToken(headers).then(res => {
        cookies.set('token', res.data, { expires: new Date(Date.now() + 3601 * 1000) })
        localStorage.setItem('expired', Date.now());
        localStorage.setItem('token', res.data);
        toast.current.show({ severity: 'info', summary: 'Confirmado', detail: 'Tu sesión se extendio 60 minutos', life: 5000 });
        renoveSesion();
      }).catch(err => {
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    } if (!cookies.get('token')) {
      window.location.href = "./Login"
    }
  }

  const reject = () => {
    authenticationService.signOut();
    toast.current.show({ severity: 'info', summary: 'Rechazado', detail: 'Fin de la sessión', life: 5000 });
  }

  const onHide = () => {
    // reject()
  }

  function sayHi() {
    audioElement.play();
    confirmDialog({
      header: 'En 2 minutos se termina la sesión',
      message: '¿Desea extender la sesión?',
      icon: 'pi pi-info-circle',
      accept,
      reject,
      onHide,
      closable: false
    });
  }



  return (
    <>
      <Toast ref={toast} position="bottom-center" />
      <ConfirmDialog />
    </>
  )
}

export default RenewSession